module.exports = __webpack_public_path__ + "img/Logo contact.68ca2846.svg";